import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: ['package:apps.summit'],
  description: 'Summit pre-filled with Attain Apps internal strategic plan',
  name: 'Summit (Attain Apps Internal)',
} as const satisfies core.quiver.Package
